import classNames from 'classnames';
import BButton from 'components/common/BButton';
import Modal from 'components/common/Modal';
import useTranslation from 'next-translate/useTranslation';
import { ArrowsOutSimple } from '@phosphor-icons/react';
import { FunctionComponent, useState } from 'react';
import VehicleDetailCarousel from './VehicleDetailCarousel';
import VehicleDetailCarouselModalContent from './VehicleDetailCarouselModalContent';
import VehicleDetailGallery from './VehicleDetailGallery';

interface VehicleDetailCarouselWrapperProps {
  images: string[];
  vehicleName: string;
  wrapperClass?: string;
}

const VehicleDetailCarouselWrapper: FunctionComponent<
  VehicleDetailCarouselWrapperProps
> = ({ images, vehicleName, wrapperClass }) => {
  const { t } = useTranslation();
  const [showFullPageModal, setShowFullPageModal] = useState<boolean>(false);
  const [showFullPageGallery, setShowFullPageGallery] =
    useState<boolean>(false);
  const [initialIndex, setInitialIndex] = useState<number>(0);

  const setShowFullPageGalleryWithInitialIndex = (idx: number) => {
    setInitialIndex(idx);
    setShowFullPageGallery(true);
  };

  return (
    <section className={classNames('vehicle-carousel relative', wrapperClass)}>
      <VehicleDetailCarousel
        images={images}
        vehicleName={vehicleName}
        onImageClick={() => setShowFullPageModal(true)}
      />
      <BButton
        variant="info"
        priority="outlined"
        className="absolute bottom-6 right-6 hidden text-sm shadow-lg md:inline-block"
        onClick={() => setShowFullPageModal(true)}
      >
        <div className="flex items-center">
          <ArrowsOutSimple className="mr-2 h-4 w-4" />
          <span>{t('vehicle:seeAllPhotos')}</span>
        </div>
      </BButton>
      <Modal
        modalClass="w-full h-full"
        show={showFullPageModal}
        setShow={setShowFullPageModal}
        removeSlideToClose
      >
        <VehicleDetailCarouselModalContent
          images={images}
          vehicleName={vehicleName}
          onImageClick={setShowFullPageGalleryWithInitialIndex}
        />
      </Modal>
      <Modal
        setShow={setShowFullPageGallery}
        show={showFullPageGallery}
        modalClass="w-full h-full bg-slate-900"
        modalBodyClass="h-full"
        noLayout
        fullScreen
        removeSlideToClose
      >
        <VehicleDetailGallery
          images={images}
          vehicleName={vehicleName}
          setShow={setShowFullPageGallery}
          initialIndex={initialIndex}
        />
      </Modal>
    </section>
  );
};

export default VehicleDetailCarouselWrapper;
